export enum APP_STORAGE_KEYS {
  STUDENT_MODE = 'ED_STUDENT_MODE',
  ED_LANGUAGE_SELECTED = 'ED_LANGUAGE_SELECTED'
}

export enum APP_STUDENT_MODE {
  PAPER = 'PAPER',
  BOOK = 'BOOK',
  NORMAL = 'NORMAL'
}

export enum APP_EVENT_BUS {
  LANGUAGE_CHANGED = 'LANGUAGE_CHANGED',
  APP_READY = 'APP_READY',
  APP_INSTITUTION_READY = 'APP_INSTITUTION_READY',
  APP_SOCKET_READY = 'APP_SOCKET_READY',
  APP_SESSION_READY = 'APP_SESSION_READY'
}

export enum _APP_STORE {
  SET_FILE_EXT_NOT_ALLOWED = 'AppStore/setFileExtNotAllowed',
  GET_INITIAL_DATA = 'AppStore/getInitialData',
  GET_VERSION_DATA = 'AppStore/getVersionData',
  SET_INSTITUTIONS_LOADED = 'AppStore/setInstitutionsLoaded',
  SET_ACTIVE_SCHOOL_DAYS_LOADED = 'AppStore/setActiveSchoolDaysLoaded',
  SET_COPYRIGHTS_COLOR = 'AppStore/setCopyrightsColor',
  CHANGE_ROUTER = 'AppStore/changeRouter',
  TOGGLE_SIDEBAR = 'AppStore/toggleSidebar',
  SHOW_SIDEBAR = 'AppStore/showSidebar',
  CHANGE_FOOTER_TYPE = 'AppStore/changeFooterType',
  SET_HEADER_VISIBLE = 'AppStore/setHeaderVisible',
  SET_MEMBER_POSITION = 'AppStore/setMemberPosition',
  SET_SOCKET_CONNECTED = 'AppStore/setSocketConnected',
  SET_PRESENTATION_SOCKET_CONNECTED = 'AppStore/setPresentationSocketConnected',
  SET_USER_MODE = 'AppStore/setUserMode',
  UPDATE_PREVIOUS_DISCONNECTION_SOCKET = 'AppStore/updatePreviousDisconnectionSocket',
  SET_SIDEBAR_BUTTON = 'AppStore/setSidebarButton',
  SET_APP_READY = 'AppStore/setAppReady',
  UPDATE_BOARD_PREVIOUS_DISCONNECTION_SOCKET = 'AppStore/updateBoardPreviousDisconnectionSocket',
  SET_ACTIVE_WEBVIEW = 'AppStore/setActiveWebwiew',
  SET_EXPAND_CALENDAR = 'AppStore/setExpandCalendar',
  ADD_ERROR_LOG = 'AppStore/addErrorLog',
  CLEAN_ERROR_LOG= 'AppStore/cleanErrorLog',
  SET_SUBJECT_BUILDER_ACTIVE = 'AppStore/setSubjectBuilderActive',
}
